/**
 * @graph-stack quality-atelier
 * @graph-domain Quality
 * @graph-business API URL・アプリ名・React Queryキャッシュ設定の環境設定
 * @graph-connects none
 */
export const config = {
  apiUrl: (import.meta.env.VITE_API_URL as string | undefined) ?? '/api',
  appName: 'Quality Atelier',
  query: {
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
  },
};
